<template>
    <div class="chatbot-button" @click="openChatBot">
        <img src="@/assets/images/chatbot/robot_icon.svg" />
        <img src="@/assets/images/chatbot/logo.svg" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ShowChatBotButton',
        computed: {
            ...mapGetters({
                showChatBot: 'ChatBot/getShowChatBot'
            })
        },
        methods: {
            async openChatBot () {
                if (this.isMobileView) {
                    document.body.classList.add('eva-chatbot-open-mobile')
                }
                await this.$store.dispatch('ChatBot/setShowChatBot', true)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .chatbot-button {
        gap: 10px;
        right: 0;
        height: 50px;
        width: 100px;
        position: fixed;
        z-index: 2000;
        background: linear-gradient(138deg, #973F00 0%, #cf6f2a, #C65300 100%);
        top: 12%;
        display: flex;
        align-items: center;
        border-radius: 10px 0 0 10px;
        justify-content: center;
        cursor: pointer;
        animation: gradient 5s ease infinite;
        box-shadow: 0px 4px 4px 0px #00000040;
        transition: all .3s ease;
        background-size: 300% 300%;
        animation: gradient-animation 3.5s linear 1s infinite alternate;

        [class*="mobile"] & {
            top: 80%;
            height: 40px;
            width: 80px;
        }

        &:hover {
            transform: scale(1.2);
        }
    }

    @keyframes gradient-animation {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }

</style>
